import React, { useRef } from 'react'
import useWpJson from '../../Hooks/useWpJson'
import useSliderMethods from '../../Hooks/useSliderMethods'
import { Transition } from 'react-transition-group'
import { GrPrevious, GrNext } from 'react-icons/gr'
export default function TestimoniesComponent ({ post }) {
  const jsonResponse = useWpJson(post)
  const nodeRef = useRef(null)
  const {
    setTimer,
    removeTimer,
    previousImage,
    nextImage,
    currentSlide
  } = useSliderMethods({
    loopTime: 10000,
    loop: jsonResponse
  })
  return (
    <div className='flex w-full m-auto h-[400px] items-center justify-center'
    onMouseEnter={removeTimer}
      onMouseLeave={setTimer}
    >
      <div className='flex w-full max-w-2xl h-full relative items-center justify-center'>
        <button onClick={previousImage} className='absolute w-1/3 hover:opacity-60 opacity-0 h-full transition-all z-20 left-0 px-4 justify-start inline-flex items-center group'>
          <span className='bg-white/50 group-hover:translate-x-0 -translate-x-full transition-all duration-700 inline-flex absolute rounded-full p-2 invert'>
            <GrPrevious size={'32px'} />
          </span>
        </button>
        {jsonResponse &&
          jsonResponse.map((post, index) => (
            <Transition
              nodeRef={nodeRef}
              in={index === currentSlide}
              timeout={1000}
              key={index}
            >
              {state => (
                <div
                  className={`gallery gallery-${state} w-full m-auto absolute flex flex-col h-full overflow-hidden justify-center items-center`}
                  ref={nodeRef}
                  key={index}
                >
                  <p
                    className='text-4xl relative z-10  text-center font-text_highlight '
                    dangerouslySetInnerHTML={{ __html: post.title.rendered }}
                  />
                  <p className='text-md relative z-10  text-center font-text_accent '>
                    {post?.acf?.testimony}
                  </p>
                  <p className='text-sm relative z-10  text-center font-text_accent '>
                    {post?.acf?.rating}
                  </p>
                  <p className='text-sm relative z-10  text-center font-text_accent '>
                    {post?.acf?.date}
                  </p>
                  <p className='text-sm relative z-10  text-center font-text_accent '>
                    {post?.acf?.name}
                  </p>
                </div>
              )}
            </Transition>
          ))}
        <button onClick={nextImage} className='absolute w-1/3 h-full hover:opacity-60 opacity-0 transition-all z-20 right-0 px-4 justify-end inline-flex items-center group'>
          <span className='bg-white/50 group-hover:-translate-x-0 translate-x-full transition-all duration-700 inline-flex absolute rounded-full p-2 invert'>
            <GrNext size={'32px'} />
          </span>
        </button>
      </div>
    </div>
  )
}
